/* Silvano — carrosséis: dica de arraste (mobile) + setas (desktop).
   Portado do SwipeHint do Hydrogen. Sem dependências. */
(function () {
  'use strict';

  function trackOf(wrap) { return wrap.querySelector('[data-sv-rail-track]'); }
  function overflows(track) { return track.scrollWidth > track.clientWidth + 4; }

  document.querySelectorAll('[data-sv-rail]').forEach(function (wrap) {
    var track = trackOf(wrap);
    if (!track) return;

    /* ---- dica de arraste (mão) ---- */
    var hint = wrap.querySelector('[data-sv-swipe-hint]');
    if (hint) {
      var dismissed = false;
      var dismiss = function () { dismissed = true; hint.classList.remove('is-show'); };
      // O scroll-snap dispara eventos de scroll sozinho no load (scrollLeft 0) —
      // por isso só dispensamos quando o track REALMENTE moveu, ou no 1º toque.
      track.addEventListener('scroll', function () {
        if (!dismissed && track.scrollLeft > 4) dismiss();
      }, { passive: true });
      track.addEventListener('touchstart', dismiss, { passive: true, once: true });
      track.addEventListener('pointerdown', dismiss, { passive: true, once: true });
      track.addEventListener('wheel', dismiss, { passive: true, once: true });

      var reveal = function () { if (!dismissed && overflows(track)) hint.classList.add('is-show'); };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) reveal(); });
        }, { threshold: 0.4 });
        io.observe(hint);
      } else {
        reveal();
      }
    }

    /* ---- setas (desktop) ---- */
    var arrows = wrap.querySelectorAll('[data-sv-rail-arrow]');
    if (arrows.length) {
      var syncArrows = function () {
        arrows.forEach(function (b) { b.classList.toggle('is-on', overflows(track)); });
      };
      arrows.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = btn.getAttribute('data-sv-rail-arrow') === 'prev' ? -1 : 1;
          track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' });
        });
      });
      syncArrows();
      window.addEventListener('resize', syncArrows);
    }
  });
})();
